import { User } from '../../domain/entities/User';
import { Email } from '../../domain/value-objects/Email';
import { UserPreferences } from '../../domain/value-objects/UserPreferences';
import { UserDTO } from '../dto/UserDTO';

/**
 * User Mapper
 * Converts between User entity and UserDTO
 */
export class UserMapper {
  static toDTO(user: User): UserDTO {
    return {
      id: user.id,
      workspaceId: user.workspaceId ?? '',
      name: user.name,
      fullName: user.fullName,
      email: user.email.value,
      role: user.role,
      avatar: user.avatar,
      googleId: user.googleId ?? undefined,
      preferences: user.preferences.toJSON(),
      mustChangePassword: user.mustChangePassword,
      createdAt: user.createdAt,
      updatedAt: user.updatedAt,
    };
  }

  static toDomain(dto: UserDTO): User {
    return new User({
      id: dto.id,
      workspaceId: dto.workspaceId,
      googleId: dto.googleId ?? null,
      email: new Email(dto.email),
      passwordHash: null,
      fullName: dto.fullName,
      role: dto.role,
      avatar: dto.avatar,
      preferences: dto.preferences
        ? UserPreferences.create(dto.preferences)
        : UserPreferences.create(),
      mustChangePassword: dto.mustChangePassword,
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt,
    });
  }
}
